import { useEffect } from "react";

export const useHideElements = (elements) => {
  useEffect(() => {
    const selectedElements = document.querySelectorAll(elements.join(","));
    selectedElements.forEach((element) => {
      element.style.display = "none";
    });

    return () => {
      selectedElements.forEach((element) => {
        element.style.display = "block";
      });
    };
  }, [elements]);
};
